export default "__VITE_ASSET__9a17365f__"